//*********************************
// logostripe.js
//*********************************

class LogoStripe {
    constructor() {
        this.wrapper = document.getElementById('logoWrapper');
        this.playPauseBtn = document.getElementById('playPauseBtn');
        this.speedUpBtn = document.getElementById('speedUpBtn');
        this.slowDownBtn = document.getElementById('slowDownBtn');
        this.resetBtn = document.getElementById('resetBtn');
        
        this.isPaused = false;
        this.currentSpeed = 30; // Sekunden für eine komplette Animation
        this.minSpeed = 10;     // Schnellste Animation
        this.maxSpeed = 60;     // Langsamste Animation
        
        this.init();
    }
    
    init() {
	    if(this.wrapper){
        this.setupEventListeners();
        this.duplicateLogos();
					}
    }
    
    // Dupliziert die Logos für seamless loop
    duplicateLogos() {
        // Bereits im HTML dupliziert für bessere Performance
        //console.log('Logo Stripe initialisiert mit', this.wrapper.children.length, 'Logos');
    }
    
    setupEventListeners() {
        // Play/Pause Button
        this.playPauseBtn.addEventListener('click', () => {
            this.togglePlayPause();
        });
        
        // Speed Controls
        this.speedUpBtn.addEventListener('click', () => {
            this.changeSpeed(-5); // Verringert die Zeit = schneller
        });
        
        this.slowDownBtn.addEventListener('click', () => {
            this.changeSpeed(5); // Erhöht die Zeit = langsamer
        });
        
        // Reset Button
        this.resetBtn.addEventListener('click', () => {
            this.reset();
        });
        
        // Hover Events
        this.wrapper.addEventListener('mouseenter', () => {
            this.pauseAnimation();
        });
        
        this.wrapper.addEventListener('mouseleave', () => {
            if (!this.isPaused) {
                this.resumeAnimation();
            }
        });
    }
    
    togglePlayPause() {
        if (this.isPaused) {
            this.resumeAnimation();
            this.playPauseBtn.textContent = 'Pausieren';
            this.playPauseBtn.classList.remove('paused');
            this.isPaused = false;
        } else {
            this.pauseAnimation();
            this.playPauseBtn.textContent = 'Abspielen';
            this.playPauseBtn.classList.add('paused');
            this.isPaused = true;
        }
    }
    
    pauseAnimation() {
        this.wrapper.style.animationPlayState = 'paused';
    }
    
    resumeAnimation() {
        this.wrapper.style.animationPlayState = 'running';
    }
    
    changeSpeed(change) {
        this.currentSpeed = Math.max(
            this.minSpeed, 
            Math.min(this.maxSpeed, this.currentSpeed + change)
        );
        
        this.wrapper.style.animationDuration = `${this.currentSpeed}s`;
        
        console.log(`Geschwindigkeit geändert: ${this.currentSpeed}s`);
    }
    
    reset() {
        this.currentSpeed = 30;
        this.wrapper.style.animationDuration = `${this.currentSpeed}s`;
        this.wrapper.style.animationPlayState = 'running';
        
        this.playPauseBtn.textContent = 'Pausieren';
        this.playPauseBtn.classList.remove('paused');
        this.isPaused = false;
        
        // Reset der Animation
        this.wrapper.style.animation = 'none';
        setTimeout(() => {
            this.wrapper.style.animation = `scroll ${this.currentSpeed}s linear infinite`;
        }, 10);
        
        console.log('Animation zurückgesetzt');
    }
}

// Initialisiere die Logo Stripe Animation wenn die Seite geladen ist
document.addEventListener('DOMContentLoaded', () => {
    new LogoStripe();
});

// Zusätzliche Utility-Funktionen

// Performance-optimierte Scroll-Animation
function optimizeAnimation() {
    const wrapper = document.getElementById('logoWrapper');
    if(wrapper){
    
	    // Verwende transform3d für Hardware-Beschleunigung
	    wrapper.style.transform = 'translateZ(0)';
	    wrapper.style.willChange = 'transform';
	    
	    // Reduziere repaint bei Hover-Effekten
	    const logos = wrapper.querySelectorAll('img');
	    logos.forEach(logo => {
	        logo.style.willChange = 'transform, filter';
	    });
    
			}
}

// Responsive Anpassungen und Logo-Größen-Optimierung
function handleResize() {
    const wrapper = document.getElementById('logoWrapper');
    const containerWidth = wrapper.parentElement.offsetWidth;
    
    console.log(`Container Breite: ${containerWidth}px`);
    
    // Anpassung der Animation-Geschwindigkeit basierend auf Container-Größe
    if (containerWidth < 768) {
        wrapper.style.animationDuration = '25s'; // Schneller auf mobilen Geräten
    }
}

// Optimiert die Logo-Größen nach dem Laden
function optimizeLogoSizes() {
    const logos = document.querySelectorAll('.logo-wrapper img');
    
    logos.forEach((logo, index) => {
        logo.addEventListener('load', function() {
            const naturalWidth = this.naturalWidth;
            const naturalHeight = this.naturalHeight;
            const aspectRatio = naturalWidth / naturalHeight;
            
            // Berechne optimale Breite basierend auf dem Seitenverhältnis
            const targetHeight = parseInt(getComputedStyle(this).height);
            const calculatedWidth = targetHeight * aspectRatio;
            
            console.log(`Logo ${index + 1}: Natürliche Größe ${naturalWidth}x${naturalHeight}, Berechnete Breite: ${calculatedWidth}px`);
            
            // Setze optimale Breite (innerhalb der definierten Grenzen)
            const minWidth = window.innerWidth <= 480 ? 60 : (window.innerWidth <= 768 ? 80 : 100);
            const maxWidth = window.innerWidth <= 480 ? 160 : (window.innerWidth <= 768 ? 200 : 280);
            
            const optimizedWidth = Math.max(minWidth, Math.min(maxWidth, calculatedWidth));
            this.style.width = optimizedWidth + 'px';
            
            // Setze auch die Container-Breite entsprechend
            const container = this.parentElement;
            const containerPadding = 20; // Zusätzlicher Platz
            container.style.width = (optimizedWidth + containerPadding) + 'px';
        });
    });
}

// Event Listeners für Optimierungen
window.addEventListener('load', () => {
    optimizeAnimation();
    optimizeLogoSizes();
});
window.addEventListener('resize', handleResize);

// Debug-Informationen (können in Produktion entfernt werden)
console.log('logostripe');
//console.log('Logo Stripe Animation geladen');
//console.log('Verfügbare Methoden: togglePlayPause(), changeSpeed(), reset()');
